export default {
  icon: 'w-8 h-8 text-[2rem] mr-2 max-w-[30rem]'
}
